module.exports = __webpack_public_path__ + "img/doorbell_pairing_mode.a3420c6c.png";